import { getCustomer } from './customer';

const loadingStatus = {
	IDLE: 'idle',
	LOADING: 'loading',
	SUCCEEDED: 'succeeded',
	FAILED: 'failed',
};

const getHeaders = () => {
	const token = getCustomer().token;
	return token ? { Authorization: `Bearer ${token}` } : {};
};

// В dev с proxy запрос идёт на тот же origin — CORS не нужен
const isDevWithProxy =
	typeof window !== 'undefined' &&
	/^(https?:\/\/)?(localhost|127\.0\.0\.1)(:\d+)?$/.test(window.location.origin);

// Может быть абсолютным (https://rayanhalal.ru/site) или относительным (/api для nginx-прокси)
const SERVER_URL_FULL =
	process.env.REACT_APP_SERVER_URL ||
	process.env.REACT_APP_DEV_URL ||
	'https://rayanhalal.ru/site';

const SERVER_URL = isDevWithProxy ? '' : SERVER_URL_FULL;
const getBasePath = () => (isDevWithProxy ? '/site' : '');

/** База для img/asset URL: в dev через proxy (/site), иначе полный URL бэка */
const getAssetBase = () => (isDevWithProxy ? '/site' : SERVER_URL_FULL);

const fetcher = async (endpoint, options = {}) => {
	try {
		const basePath = getBasePath();
		const fullPath = basePath
			? `${basePath}${endpoint.startsWith('/') ? endpoint : '/' + endpoint}`
			: `${SERVER_URL_FULL}${endpoint}`;
		// База должна быть валидным абсолютным URL. window.location.origin подходит всегда.
		// Если fullPath абсолютный — база игнорируется; если относительный (например /api/...) — резолвится корректно.
		const base =
			typeof window !== 'undefined' && window.location && window.location.origin
				? window.location.origin
				: 'https://rayanhalal.ru';
		const url = new URL(fullPath, base);
		const params = new URLSearchParams(url.search);
		params.set('store_id', getCustomer().store_id);
		const token = getCustomer().token;
		if (token) params.set('auth_token', token);
		// Если итоговый origin совпадает с текущим (dev proxy или prod через nginx /api → бэкенд) —
		// шлём same-origin запрос без протокола/хоста, чтобы не триггерить CORS.
		const sameOrigin =
			typeof window !== 'undefined' &&
			window.location &&
			url.origin === window.location.origin;
		const requestUrl = sameOrigin
			? `${url.pathname}?${params.toString()}`
			: `${url.origin}${url.pathname}?${params.toString()}`;
		const headers = { ...getHeaders(), ...(options.headers || {}) };
		if (endpoint.includes('account/signin')) {
			headers['X-Store'] = 'wholesale';
		}
		const response = await fetch(requestUrl, {
			...options,
			headers,
		});
		return response;
	} catch (e) {
		// TODO: logger
		alert(`Fatal error from fetcher: ${e.toString()}`);
	}
	return false;
};

export default fetcher;

export {
	SERVER_URL,
	SERVER_URL_FULL,
	getAssetBase,
	getHeaders,
	loadingStatus,
};
